import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserData } from './user-data';

@Injectable({
  providedIn: 'root'
})
export class MockData {
  data: any;

  constructor(public http: HttpClient, public user: UserData) {}

  login_cliente(): any { return this.http.get('assets/data/login_cliente.json') }
  movil_app_config(): any { return this.http.get('assets/data/movil_app_config.json') }
  // customer_items(): any { return this.http.get('assets/data/customer_items.json') }
  // orders(): any { return this.http.get('assets/data/orders.json') }
  // order(): any { return this.http.get('assets/data/order.json')

  notifications(): any { return this.http.get('assets/data/notifications.json') }
  notification(): any { return this.http.get('assets/data/notification.json') }
  visits(): any { return this.http.get('assets/data/visits.json') }
  visit(): any { return this.http.get('assets/data/visit.json') }
  therapies(): any { return this.http.get('assets/data/therapies.json') }
  therapy(): any { return this.http.get('assets/data/therapy.json') }
  schedule(): any { return this.http.get('assets/data/schedule.json') }
  contact(): any { return this.http.get('assets/data/contact.json') }

}
